import t from 'tcomb';
import { get, post } from '../../endpoint';

export default class Server {

  constructor(api_url) {
    t.assert(t.Str.is(api_url));
    this.api_url = api_url;
  }

  doLogin({ email, password }, callback) {
    post({
      url: `${this.api_url}user/login`,
      payload: { emailAddress: email, password }
    }, callback);
  }

  doLogout(callback) {
    post({
      url: `${this.api_url}user/logout`
    }, callback);
  }

  doResendPassword({email}, callback) {
    post({
      url: `${this.api_url}user/password/reset`,
      payload: {emailAddress: email}
    }, callback);
  }

  doChangePassword({ old_password, new_password }, callback){
    post({
      url: `${this.api_url}user/password`,
      payload: { oldPassword: old_password, newPassword: new_password }
    }, callback);
  };

  doUpdateAccount({name, surname, gender, birth_date, country, district, zip, com_locale}, callback){
    post({
      url: `${this.api_url}user`,
      payload: { name, surname, gender, birth_date, country, district, zip,  com_locale}
    }, callback);
  };

  loadPurchases(callback){
    get({ url: `${this.api_url}user/orders` }, callback);
  };

  loadPurchase({purchase_id, target, cancel_target}, callback){
    get({ url: `${this.api_url}order/${purchase_id}?target=${target}&cancel_target=${cancel_target}` }, callback);
  };

  doSendGiftCardCode({purchase_id, target, cancel_target, gift_card_code}, callback){
    post({
      url: `${this.api_url}order/${purchase_id}/giftcard`,
      payload: { gift_card_code, target, cancel_target}
    }, callback);
  };

  loadFacebook({target, locale}, callback){
    post({
      url: `${this.api_url}user/login/facebook`,
      payload: {target, com_locale: locale}
    }, callback);
  };

  loadGoogle({target, locale}, callback){
    post({
      url: `${this.api_url}user/login/google`,
      payload: {target, com_locale: locale}
    }, callback);
  };

  loadTwitter({target, locale}, callback){
    post({
      url: `${this.api_url}user/login/twitter`,
      payload: {target, com_locale: locale}
    }, callback);
  };

  loadMicrosoft({target, locale}, callback){
    post({
      url: `${this.api_url}user/login/microsoft`,
      payload: {target, com_locale: locale}
    }, callback);
  };
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/Server.js
 **/